import { useMemo } from 'react';

import { useAgentsMap, useListFetch, useSort } from '../../../hooks';
import { getAgentsBilling } from '../../../api';
import { getAgentTitle, sortArray } from '../../../utilities';
import { useBillingLastRefreshedDate } from './useBillingLastRefreshedDate';

export const useAgentsBilling = () => {
  const { sort, setSort } = useSort({ name: 'title', direction: 'asc' }, false);
  const agentsShortMap = useAgentsMap();
  const { lastRefreshedDate, isLastRefreshedDateLoading } =
    useBillingLastRefreshedDate();

  const {
    nodes: rawAgents,
    filters: agentsFilters,
    setFilters: setAgentsFilters,
    intializing: agentsLoading,
    ...rest
  } = useListFetch(
    async params => {
      const response = await getAgentsBilling({
        startTime: params?.filters?.started_at,
        endTime: params?.filters?.ended_at,
      });

      return {
        total: 0,
        totalVoice: response.totalBillableVoiceSeconds,
        totalText: response.totalBillableTextSeconds,
        totalElements: response.agentsBilling?.length || 0,
        totalVideo: response.totalBillableVideoSeconds,
        content: response.agentsBilling || [],
      };
    },
    {
      withQueryParams: true,
    }
  );

  const enrichedAgents = useMemo(() => {
    return (rawAgents || []).map(agent => ({
      ...agent,
      title: getAgentTitle(agentsShortMap, agent?.agentId),
    }));
  }, [rawAgents, agentsShortMap]);

  const sortedAgents = useMemo(() => {
    return sortArray(enrichedAgents, sort);
  }, [enrichedAgents, sort]);

  return {
    ...rest,
    agentsSort: sort,
    agents: sortedAgents,
    agentsFilters,
    setAgentsFilters,
    setAgentsSort: setSort,
    agentsLoading,
    lastRefreshedDate,
    isLastRefreshedDateLoading,
  };
};
